import { Suspense, lazy, useCallback, useState } from 'react';
import AlwaysOnIframe from './AlwaysOnIframe';
import { useHostAppContext } from '../hostAppContext/hooks/useAppContext';
// @ts-expect-error ts-migrate(2307)
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
// @ts-expect-error ts-migrate(2307)
import { reportingReferenceResolvers } from 'reporting-data/public/reference-resolvers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProvideReportingReferenceResolvers = ProvideReferenceResolvers(reportingReferenceResolvers);
const AsyncUIIFrameVariant = /*#__PURE__*/lazy(() => import('./UIIFrameVariant'));

// We load this separately because we need to run it immediately but we don't
// want to load the rest of the app. It's code split so we don't have to load
// ui-addon-iframeable until we need it because most use cases use the nav and
// therefore won't need it at all.
//
// See: https://git.hubteam.com/HubSpot/chatspot-ui/pull/1130
const AsyncIframeConnector = /*#__PURE__*/lazy(() => import('./IframeConnector'));
const UIIFrameVariantAppContainer = ({
  startOpen
}) => {
  const {
    variant
  } = useHostAppContext();
  const [shouldRenderApp, setShouldRenderApp] = useState(startOpen);
  const enableAppRender = useCallback(() => {
    setShouldRenderApp(true);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AlwaysOnIframe, {
      enableAppRender: enableAppRender
    }), /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: /*#__PURE__*/_jsx(AsyncIframeConnector, {
        variant: variant,
        children: shouldRenderApp && /*#__PURE__*/_jsx(Suspense, {
          fallback: null,
          children: /*#__PURE__*/_jsx(AsyncUIIFrameVariant, {})
        })
      })
    })]
  });
};
export default ProvideReportingReferenceResolvers(UIIFrameVariantAppContainer);